import React, { useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
import close from "Assets/images/cross_icon.png"
// css
import styles from "./StaffClientsModal.module.scss";
import { CloseIcon } from "Assets/icons";
import { PdfPeerForm, PdfPublishForm } from "helpers/common";

const PdfPeerModal = ({ show, setShow, guardianList, clientType, handleSubmit, publishPdfCheckbox = false, isClassroom = false }) => {

    const handlePopup = () => setShow(false)

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AddNewGoalPop} modal-v2  AddNewGoalPop`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            // style={{maxWidth: "377px"}}
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div className="reports-v2">
                        <div className="section-title d-flex align-items-center justify-content-end border-bottom-0 m-0" style={{ borderColor: "#315D99" }}>
                            {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"SUBMIT & EXPORT"}</h6> */}
                            <img onClick={handlePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                        </div>
                        <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                            <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99", padding: 0 }}>{"EMAIL TO"}</h6>
                        </div>

                        {isClassroom ? (
                            // <PdfPublishFormClassroom publishPdfCheckbox={publishPdfCheckbox} guardianList={guardianList} clientType={clientType} handleSubmit={handleSubmit} />
                            <></>
                        ) : (
                            <PdfPeerForm publishPdfCheckbox={publishPdfCheckbox} guardianList={guardianList} clientType={clientType} handleSubmit={handleSubmit} />
                        )}
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default PdfPeerModal;